import { useEffect, useState } from 'react';
import axios from 'axios';
import TeamMemberCard from '../components/TeamMemberCard';
import Banner from '../components/Banner';

function TeamPage() {
  const [teamMembers, setTeamMembers] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/team`)
      .then(res => setTeamMembers(res.data))
      .catch(err => console.error(err));
  }, []);

  return (
    <>
        <Banner title="團隊介紹" backgroundImage="" />
        <div className="max-w-6xl mx-auto px-4 py-10 grid gap-8 grid-cols-1 sm:grid-cols-1 md:grid-cols-1">
        {teamMembers.map(member => (
            <TeamMemberCard key={member.id} {...member} />
        ))}
        </div>
    </>
  );
}

export default TeamPage;
